import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './apiClient';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Een boodschappenlijst is een gedeeld kladblok: iemand anders zet er
      // ondertussen iets op. Bij terugkomst op het tabblad opnieuw ophalen.
      refetchOnWindowFocus: true,
      staleTime: 10_000,
      // Op een 4xx heeft opnieuw proberen geen zin; de sessie of de invoer is
      // het probleem, niet het netwerk.
      retry: (count, error) =>
        error instanceof ApiError && error.status < 500 ? false : count < 2,
    },
  },
});
